import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { Table, Spin, Button, Modal, Tooltip } from "antd";
import { EditOutlined, DeleteOutlined } from "@ant-design/icons"; // Icons from Ant Design
import SizeCreationForm from "../../Forms/SizeCreationForm/SizeCreationForm"
const SizeTable = ({
  history,
  loading,
  data,
  callReFetch,
  dispatch,
  handleDelete,
}) => {
  const [isEditModalVisible, setIsEditModalVisible] = useState(false);
  const [selectedSize, setSelectedSize] = useState(null);
  const [isMobileView, setIsMobileView] = useState(window.innerWidth < 768);

  // Update isMobileView based on window size
  useEffect(() => {
    const handleResize = () => {
      setIsMobileView(window.innerWidth < 768);
    };

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const handleOpenEditModal = async (id) => {
    const sizeToEdit = data.find((size) => size._id === id);
    if (sizeToEdit) {
      setSelectedSize(sizeToEdit);
      setIsEditModalVisible(true);
    }
  };

  const handleCloseEditModal = () => {
    setIsEditModalVisible(false);
    setSelectedSize(null);
  };

  const renderActionButton = (id) => (
    <>
      {isMobileView ? (
        // Use icons on mobile view
        <>
          <Tooltip title="Edit">
            <Button
              icon={<EditOutlined />}
              onClick={() => handleOpenEditModal(id)}
              size="small"
              shape="circle"
              style={{ marginRight: 8 }}
            />
          </Tooltip>
          <Tooltip title="Delete">
            <Button
              icon={<DeleteOutlined />}
              onClick={() => handleDelete(id)}
              size="small"
              shape="circle"
              danger
            />
          </Tooltip>
        </>
      ) : (
        // Use buttons on desktop view
        <>
          <Button
            onClick={() => handleOpenEditModal(id)}
            style={{ marginRight: 8 }}
          >
            Edit
          </Button>
          <Button onClick={() => handleDelete(id)} danger>
            Delete
          </Button>
        </>
      )}
    </>
  );

  const handleTableOnChange = (pagination, filteredInfo, sorter) => {
    dispatch({ type: "sorter", payload: sorter });
    dispatch({ type: "filteredInfo", payload: filteredInfo });
    callReFetch();
  };

  const columns = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      sorter: true,
    },
    {
      title: "Code",
      dataIndex: "code",
      key: "code",
      sorter: true,
    },
    {
      title: "Action",
      render: (item) => renderActionButton(item._id),
      width: 400,
    },
  ];

  return (
    <>
      <div style={{width: "50vw"}}>
        <Spin spinning={loading}>
          {data && (
            <Table
              columns={columns}
              dataSource={data}
              onChange={(pagination, filteredInfo, sorter) =>
                handleTableOnChange(pagination, filteredInfo, sorter)
              }
            />
          )}
        </Spin>
        <Modal
          title="Edit Size"
          open={isEditModalVisible}
          footer={null}
          onCancel={handleCloseEditModal}
        >
          <SizeCreationForm
            history={history}
            isEditMode
            callReFetch={callReFetch}
            data={selectedSize}
            onClose={handleCloseEditModal}
          />
        </Modal>
      </div>
    </>
  );
};

SizeTable.propTypes = {
};

export default SizeTable;
